import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import { Stelle, StelleCollection } from '@/models/Stelle';
import type { Ref } from 'vue';

/**
 * Creates a reactive connection between a BaugemeindeCollection and its params.
 * @see useCollection for more information
 * @returns  an object with the reactive props for this collection, @see useCollection
 */

let gemeindeRef: Ref<Stelle[]> | null = null;
export function useGemeindeModels(options: UseCollectionOptions = {}) {
    if (gemeindeRef === null) {
        const gemeinde = new StelleCollection();

        const initialFilters: ApiFilter[] = [
            {
                property: 'type',
                value: 'gemeinde'
            }
        ];
        const ret = useCollection<StelleCollection, Stelle>(gemeinde, {
            ...{
                tableSort: [],
                collectionsFilter: initialFilters,
                pageSize: -1
            },
            ...options
        });
        ret.collection.query();
        gemeindeRef = ret.models as Ref<Stelle[]>;
    }
    return gemeindeRef;
}
